import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import PublicLayout from "@/components/layout/PublicLayout";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import ServicesHub from "@/pages/public/ServicesHub";
import ServicePage from "@/pages/public/ServicePage";
import ServiceAreasHub from "@/pages/public/ServiceAreasHub";
import LocationPage from "@/pages/public/LocationPage";
import Gallery from "@/pages/public/Gallery";
import Blog from "@/pages/public/Blog";
import BlogPost from "@/pages/public/BlogPost";
import PayInvoice from "@/pages/public/PayInvoice";
import PaymentSuccess from "@/pages/public/PaymentSuccess";
import PaymentCancel from "@/pages/public/PaymentCancel";
import Reviews from "@/pages/public/Reviews";
import LeaveAReview from "@/pages/public/LeaveAReview";
import FAQ from "@/pages/public/FAQ";
import Contact from "@/pages/public/Contact";
import FreeEstimate from "@/pages/public/FreeEstimate";
import UploadPhotos from "@/pages/public/UploadPhotos";
import StormDamage from "@/pages/public/StormDamage";
import DigitalReceptionist from "@/pages/public/DigitalReceptionist";
import PrivacyPolicy from "@/pages/public/PrivacyPolicy";
import Terms from "@/pages/public/Terms";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLogin from "@/pages/admin/Login";
import LeadList from "@/pages/admin/LeadList";
import LeadDetail from "@/pages/admin/LeadDetail";
import PocketDashboard from "@/pages/admin/PocketDashboard";
import StormToggle from "@/pages/admin/StormToggle";
import VerificationChecklist from "@/pages/admin/VerificationChecklist";
import AutomationEvents from "@/pages/admin/AutomationEvents";
import TesterWeek from "@/pages/admin/TesterWeek";
import ShadowInbox from "@/pages/admin/ShadowInbox";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminPhotos from "@/pages/admin/AdminPhotos";
import AdminChats from "@/pages/admin/AdminChats";

import CustomerLayout from "@/pages/customer/CustomerLayout";
import CustomerLogin from "@/pages/customer/CustomerLogin";
import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import {
    CustomerEstimates,
    CustomerInvoices,
    CustomerPayments,
    CustomerProfile,
} from "@/pages/customer/CustomerSections";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                    <Route index element={<PocketDashboard />} />
                    <Route path="leads" element={<LeadList />} />
                    <Route path="leads/:id" element={<LeadDetail />} />
                    <Route path="storm" element={<StormToggle />} />
                    <Route path="verification" element={<VerificationChecklist />} />
                    <Route path="automation-events" element={<AutomationEvents />} />
                    <Route path="tester-week" element={<TesterWeek />} />
                    <Route path="shadow-inbox" element={<ShadowInbox />} />
                    <Route path="reviews" element={<AdminReviews />} />
                    <Route path="photos" element={<AdminPhotos />} />
                    <Route path="chats" element={<AdminChats />} />
                </Route>

                {/* Customer portal — Phase 8 (dry-run preview) */}
                <Route path="/customer/login" element={<CustomerLogin />} />
                <Route path="/customer" element={<CustomerLayout />}>
                    <Route index element={<Navigate to="/customer/dashboard" replace />} />
                    <Route path="dashboard" element={<CustomerDashboard />} />
                    <Route path="estimates" element={<CustomerEstimates />} />
                    <Route path="invoices" element={<CustomerInvoices />} />
                    <Route path="payments" element={<CustomerPayments />} />
                    <Route path="profile" element={<CustomerProfile />} />
                </Route>

                {/* Public */}
                <Route element={<PublicLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<ServicesHub />} />
                    <Route path="/services/:slug" element={<ServicePage />} />
                    <Route path="/service-areas" element={<ServiceAreasHub />} />
                    <Route path="/service-areas/:slug" element={<LocationPage />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/reviews" element={<Reviews />} />
                    <Route path="/leave-a-review" element={<LeaveAReview />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/pay/:token" element={<PayInvoice />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/free-estimate" element={<FreeEstimate />} />
                    <Route path="/upload-photos" element={<UploadPhotos />} />
                    <Route path="/storm-damage" element={<StormDamage />} />
                    <Route path="/digital-receptionist" element={<DigitalReceptionist />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
